var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"page-not-found"},[_c('img',{attrs:{"src":require("../assets/media/image/page-not-found.webp")}}),_c('section',{staticClass:"page-not-found__quote-container"},[_c('h4',[_vm._v(_vm._s(_vm.$epb.messages.app.pageNotFound.introduction))]),_c('h4',{domProps:{"innerHTML":_vm._s(
        _vm.$epb.utils.compileMessage(_vm.$epb.messages.app.pageNotFound.redirection, _vm.redirectToInstance)
      )}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }